module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "chapter-number---IVP sigil_not_in_toc",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor041"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor042"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor043"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor044"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page2",
      "title": "2"
    }
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page3",
      "title": "3"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tp1"
  }, [_vm._v("THE EARLIEST"), _c('br'), _vm._v("\n    CHRISTOLOGIES")]), _vm._v(" "), _c('p', {
    staticClass: "tp3",
    attrs: {
      "id": "sigil_toc_id_1",
      "title": "Title Page"
    }
  }, [_vm._v("Five Images of Christ in"), _c('br'), _vm._v("\n    the Postapostolic Age")]), _vm._v(" "), _c('div', [_c('div', {
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/5127_graphic_TP_C.png"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "tp2"
  }, [_vm._v("JAMES L. PAPANDREA"), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ivpress.com/academic",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "IVPAcademic",
      "src": "Images/IVPAcademic.png"
    }
  })])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ceaacd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/titlepage.vue
// module id = 57
// module chunks = 0